import { Download } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";
import type { Budget } from "@/hooks/useBudgets";
import { generateBudgetPdf } from "@/lib/budgetPdf";
import { resolveProposalPdf } from "@/lib/proposalDocument";

/**
 * The one PDF button of a proposal. Opens the real document (signed, frozen
 * at send time or uploaded) and only builds the platform layout client-side
 * when the document mode is `auto`. Authored documents without a frozen PDF
 * stay disabled with the reason as tooltip (flows/proposta.md R12).
 */
export function ProposalPdfButton({
  budget,
  size = "sm",
  variant = "outline",
  className,
}: {
  budget: Budget;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  className?: string;
}) {
  const pdf = resolveProposalPdf(budget);
  const icon = <Download className="mr-1.5 h-3.5 w-3.5" />;

  if (pdf.url) {
    return (
      <Button asChild size={size} variant={variant} className={className}>
        <a href={pdf.url} target="_blank" rel="noopener noreferrer">
          {icon} {pdf.label}
        </a>
      </Button>
    );
  }

  return (
    <Button
      size={size}
      variant={variant}
      className={className}
      disabled={pdf.kind === "pending"}
      title={pdf.hint}
      onClick={pdf.kind === "generated" ? () => generateBudgetPdf(budget) : undefined}
    >
      {icon} {pdf.label}
    </Button>
  );
}
